import * as actionTypes from "../actions";

const initialState = {};

export function settingsReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_SETTINGS:
      return (state = action.payload);
    default:
      return state;
  }
}
export default settingsReducer;
